var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"lg","type":"dark","variant":"primary","fixed":"top"}},[_c('b-navbar-brand',{attrs:{"to":{ name: 'Home' }}},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":"logo","height":"34"}})]),(_vm.$store.getters['users/isAuthenticated'])?_c('b-navbar-nav',[_c('b-nav-item-dropdown',{attrs:{"text":"Catégories"}},[_c('b-dropdown-item',{attrs:{"to":{
          name: 'AddCategories'
        }}},[_vm._v("Créer une catégorie")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'CategoriesQuickSearch'
        }}},[_vm._v("Recherche rapide")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'Categories'
        }}},[_vm._v("Toutes les catégories")])],1),_c('b-nav-item-dropdown',{attrs:{"text":"Attributs"}},[_c('b-dropdown-item',{attrs:{"to":{ name: 'AddAttribute' }}},[_vm._v("Créer un attribut")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'AttributesQuickSearch'
        }}},[_vm._v("Recherche rapide")]),_c('b-dropdown-item',{attrs:{"to":{ name: 'Attributes' }}},[_vm._v("Tous les attributs")])],1),_c('b-nav-item-dropdown',{attrs:{"text":"Imports en masse"}},[_c('b-dropdown-item',{attrs:{"to":{
          name: 'ImportCsv',
          params: { importName: 'attributes' }
        }}},[_vm._v("Attributs")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'ImportCsv',
          params: { importName: 'categories' }
        }}},[_vm._v("Catégories")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'ImportCsv',
          params: { importName: 'values' }
        }}},[_vm._v("Valeurs")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'ImportCsv',
          params: { importName: 'mappings' }
        }}},[_vm._v("Mappings")])],1),_c('b-nav-item-dropdown',{attrs:{"text":"Export en masse"}},[_c('b-dropdown-item',{attrs:{"to":{
          name: 'ExportCsv',
          params: { exportName: 'values' }
        }}},[_vm._v("Value")]),_c('b-dropdown-item',{attrs:{"to":{
          name: 'ExportCsv',
          params: { exportName: 'categoriesMappings' }
        }}},[_vm._v("Mappings")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }